export const PUBLIC_URL= {
     url:'https://mindamigo.com/app'
   // url:'https://preprod.mindamigo.com/app'
}
